import { blockRef } from '@hyranai/regta-document-ir';
import { BLOCK_MINORS } from './minors.js';
import { FROZEN_BLOCKS } from '../frozen/index.js';
export { BLOCK_MINORS } from './minors.js';
export { BLOCK_LOCK_OVERRIDES } from './overrides.js';
export { REQUIRED_USAGE_PRODUCTS } from './policy.js';
export { blockVersionSamples } from './samples.js';
/** Sets each definition's `minor` from the lock (via the generated `BLOCK_MINORS`). */
export function stampBlockMinors(definitions) {
    for (const definition of definitions)
        definition.minor = BLOCK_MINORS[blockRef(definition)] ?? 0;
}
/** The catalog with every frozen superseded major in place of its live definition (same ref). */
export function withFrozenBlocks(definitions, frozen = FROZEN_BLOCKS) {
    const byRef = new Map(frozen.map((d) => [blockRef(d), d]));
    return definitions.map((d) => byRef.get(blockRef(d)) ?? d);
}
export { FROZEN_BLOCKS } from '../frozen/index.js';
//# sourceMappingURL=index.js.map